import { useEffect, useState } from 'react';
import { getRealDate } from '../../helpers/timezone-change-helper';
import { logOut, useIsAuthorized } from '../../features/auth/operations';

const localStorageKey = 'lmpm-logout-activity';
const localStorageTimeout = 8000;
const localStorageInterval = 3000;
function getShouldLogOut() {
  {
    const currentValue = parseInt(
      window.localStorage.getItem(localStorageKey) ?? '0',
    );
    if (
      currentValue !== 0 &&
      currentValue < getRealDate().getTime() - localStorageTimeout
    ) {
      console.log(
        'should log out by tab closing',
        currentValue,
        getRealDate().getTime(),
      );
      return true;
    } else {
      // this is for debug purposes for User Story 63545: Logout if browser is closed
      // todo: remove this once US is completed
      console.log(
        'will preserve login state',
        currentValue,
        getRealDate().getTime(),
      );
    }
    return false;
  }
}
const shouldLogOut = getShouldLogOut();
let logoutOnTabClosingProcessed = false;

export function useLogOutAfterTabClosing() {
  const isAuth = useIsAuthorized();
  const isAuthHasValue = isAuth !== 'loading';
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  useEffect(() => {
    if (isAuthHasValue && !logoutOnTabClosingProcessed) {
      logoutOnTabClosingProcessed = true;

      if (isAuth === true && shouldLogOut) {
        setIsLoggingOut(true);
        logOut();
      }
    }
  }, [isAuthHasValue]);

  useEffect(() => {
    function setLocalStorageValue() {
      window.localStorage.setItem(
        localStorageKey,
        getRealDate().getTime().toString(),
      );
    }
    const timerId = setInterval(setLocalStorageValue, localStorageInterval);
    setLocalStorageValue();

    const clearFunction = function () {
      clearInterval(timerId);
    };
    window.addEventListener('unload', clearFunction);

    return () => {
      window.removeEventListener('unload', clearFunction);
      clearFunction();
    };
  }, []);

  return isLoggingOut;
}
